module.exports = __webpack_public_path__ + "img/logo-mono-pos.9bbcd83b.png";